// @flow

import styled from "@emotion/styled";

import { Button } from "../styles";

const Department = styled(Button)``;

export { Department };
